import { lazy } from 'react';

export const HistoryLogList = lazy(() => import('./HistoryLogList'));
